import { baseEnvUrl, getHostEnv } from './util/url';

/**
 * If NODE_ENV is set to "production" and if we aren't developing locally, this is a non-local environment
 */
export const IS_DEPLOYED_ENV =
  process.env.NODE_ENV === 'production' &&
  window.location.host.indexOf('localhost') === -1;
const DEV_JUPITER_DOMAIN = 'https://apps.dev.jupiterone.io';
const hostEnv = getHostEnv();

/**
 * Used for determining the URL on local vs. non-local envs
 *
 * @param {string} url
 */
function getJupiterUrl(url: string) {
  return IS_DEPLOYED_ENV ? url : DEV_JUPITER_DOMAIN + url;
}

const oauthBaseUri =
  IS_DEPLOYED_ENV && hostEnv !== 'dev'
    ? 'https://jupiterone-prod-us.auth.us-east-2.amazoncognito.com'
    : 'https://jupiterone-dev.auth.us-east-1.amazoncognito.com';

const defaultOAuthLogoutUrl =
  IS_DEPLOYED_ENV && hostEnv !== 'dev'
    ? 'https://apps.us.jupiterone.io'
    : 'https://apps.dev.jupiterone.io';

const loginRedirect =
  process.env.LOGIN_REDIRECT_URI ?? (IS_DEPLOYED_ENV && hostEnv !== 'dev')
    ? 'https://apps.us.jupiterone.io/auth/v1/app-redirect'
    : 'https://apps.dev.jupiterone.io/auth/v1/app-redirect';

function getAppRedirect() {
  const url = '/auth/v1/app-redirect';
  return IS_DEPLOYED_ENV ? baseEnvUrl(url) : DEV_JUPITER_DOMAIN + url;
}

const urls = {
  baseApi: getJupiterUrl('/api'),
  graphqlApi: getJupiterUrl('/api/graphql'),
  graphqlApiComplianceV2: getJupiterUrl('/api/compliance-v2/graphql'),
  accountById: getJupiterUrl('/api/v1/accounts/${ACCOUNT_ID}'),
  accounts: getJupiterUrl('/api/v1/accounts'),
  accountsLogin: getJupiterUrl('/auth/v1/login'),
  apiKeys: getJupiterUrl('/api/v1/api-keys'),
  appRedirect: getAppRedirect(),
  authClients: getJupiterUrl('/api/v1/clients'),
  billing: getJupiterUrl('/api/v1/billing'),
  jupiteroneUrl: defaultOAuthLogoutUrl,
  defaultOAuthLogoutUrl,
  groups: getJupiterUrl('/api/v1/account/groups'),
  hostEnv: hostEnv,
  htmlPdfInitialize: getJupiterUrl('/api/html-pdf/initialize'),
  htmlPdfRun: getJupiterUrl('/api/html-pdf/run'),
  invitations: getJupiterUrl('/api/v1/invitations'),
  loginDeprecated: getJupiterUrl('/auth/v1/login'),
  logout: getJupiterUrl('/auth/v1/logout'),
  mfaSecret: getJupiterUrl('/api/v1/user/mfa-secret'),
  oauthBaseUri,
  oauth2Authorize: '/oauth2/authorize',
  loginRedirect: loginRedirect,
  oauth2Token: '/oauth2/token',
  policies: getJupiterUrl('/api/v1/policies'),
  ssoUrl: `${oauthBaseUri}/saml2/idpresponse`,
  token: getJupiterUrl('/api/v1/oauth/token'),
  tokensUrl: getJupiterUrl('/api/tokens'),
  updateMfaPreferences: getJupiterUrl('/api/v1/user/update-mfa-preferences'),
  user: getJupiterUrl('/api/v1/user'),
  accountUsers: getJupiterUrl('/api/v1/accountusers'),
  verifyCode: getJupiterUrl('/api/v1/user/verify-mfa-code'),
  // policyTemplates: getJupiterUrl('/static/policy-templates'),
  policyTemplates:
    'https://raw.githubusercontent.com/JupiterOne/security-policy-templates/main/templates',
  synchronizationJobs: getJupiterUrl('/api/persister/synchronization/jobs'),
  sampleData: getJupiterUrl('/api/persister/synchronization/sample-data'),
  encodeUrl: getJupiterUrl('/api/shortener/encode/url'),
  decodeUrl: getJupiterUrl('/api/shortener/decode/url'),
  usageUrl: getJupiterUrl('/api/usage'),
  queryExecutionV2Url: getJupiterUrl('/api/j1ql'),
  featureFlags: getJupiterUrl('/api/v1/features'),
  contactUs: 'https://info.jupiterone.com/contact-us',
  j1Docs: 'https://support.jupiterone.io',
  referenceModel: 'https://jptr.one/nacf',
  documentation: 'https://support.jupiterone.io/hc/en-us',
  communityLink: 'https://jupiterone.tribe.so/',
  requestFeatureLink:
    'https://docs.google.com/forms/d/e/1FAIpQLSf2ti3OQUYekXQLJMCQZT9vVGIVSEiOzo_2fTvl3e5FApX34A/viewform',
  // OEM Branding
  oemLogoCisco:
    'https://raw.githubusercontent.com/JupiterOne/docs/main/assets/brand/cisco/secure-cloud-insights_logo.png',
};

export default urls;
